<template>
	<div class="absolute w-full h-full top-0 pointer-events-none">
		<div v-for="x in particles" class="particles" :key="x.id" :style="{ width: `${x.width}px`, top: `${x.top}px`, left: `${x.left}px`, backgroundImage: `${x.bgImg}` }" :ref="`particle${x.id}El`" :id="`particle${x.id}El`">
			<!-- <img alt="" src="images/ball-small-gold.png" /> -->
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
gsap.registerPlugin(MotionPathPlugin);

export default {
	name: "particle-1",
	data() {
		return {
			particles: [],
			running: false,
			particleCount: 0,
			particleTimeout: [],
			context: null,
		};
	},
	methods: {
		start() {
			if (this.running == true) return;
			console.log("start dust particle");
			this.running = true;
			this.initCreateParticle();
		},
		stop() {
			console.log("stop dust particle");
			clearTimeout(this.particleTimeout);
			this.context.revert();
			this.particles = [];
			this.running = false;
		},
		initCreateParticle() {
			this.particleTimeout = setTimeout(() => {
				this.createParticle(this.particleCount);
				this.particleCount++;
				this.initCreateParticle();
			}, 150);
		},
		// width, top, left, bgImg
		createParticle(id) {
			if (this.running == false) return;

			const particleSize = Math.floor(Math.random() * 5 + 5);

			const x = Math.random() * 1024;
			const y = -100; // y-coordinate on circumference

			var bgImg = "url(images/dust.png)";

			this.particles.push({ id: id, bgImg: bgImg, width: particleSize, left: x, top: y });

			this.$nextTick(() => {
				this.context.add(() => {
					this.moveParticle(id);
				});
			});
		},
		moveParticle(id) {
			if (this.running == false) return;

			const element = this.$refs[`particle${id}El`];

			const xCurve1 = Math.floor(Math.random() * 100 - 50); //-100 to 100
			const xCurve2 = Math.floor(Math.random() * 100 - 50); //-100 to 100
			const xCurve3 = Math.floor(Math.random() * 100 - 50); //-200 to 200

			const yCurve1 = Math.floor(Math.random() * 200 + 100); //100 to 300
			const yCurve2 = Math.floor(Math.random() * 200 + 600); //600 to 800
			const yCurve3 = Math.floor(Math.random() * 300 + 1200); //1200 to 1500

			gsap.to(element, {
				duration: 8,
				force3D: true,
				motionPath: {
					path: [
						{ x: xCurve1, y: yCurve1 },
						{ x: xCurve2, y: yCurve2 },
						{ x: xCurve3, y: yCurve3 },
						{ x: 0, y: 1500 },
					],
					curviness: 1.2,
				},
				ease: "none", // Gently decelerates towards the end
				onComplete: (id) => {
					this.killParticle(id);
				},
				onCompleteParams: [id],
			});
		},
		killParticle(id) {
			const index = this.particles.findIndex((item) => item.id == id);
			this.particles.splice(index, 1);
		},
		killAllTweens() {
			this.context.revert();
		},
	},
	mounted() {
		this.context = gsap.context(() => {}, this.$el); // Scope to the component's root element
		// setTimeout(() => {
		// 	this.start();
		// }, 500);
	},
};
</script>

<style scoped>
.particles {
	position: absolute;
	aspect-ratio: 1;
	border-radius: 100%;
	z-index: 30;
	background-size: contain;
	background-repeat: no-repeat;
	will-change: transform;
	overflow: visible;
}
</style>
